module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_intro"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_XI"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("INTRODUCTION")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("WHAT THIS BOOK AIMS TO DO")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("This book aims to help students study the Prophets. Like other volumes in the "), _c('i', [_vm._v("EOT ")]), _vm._v("and "), _c('i', [_vm._v("ENT ")]), _vm._v("series, it is intended to give the student a primary resource to enable him or her to study the texts independently. It provides introductory material on each book, a basic commentary, and pointers to theological interpretation. It is also interactive. Interspersed in the interpretation are a number of panels, which invite the student to think about what has been learnt (Think about), or to take an aspect of the study further (Digging deeper). Some of the panels are simply background notes, supplying extra information to clarify difficult issues or points. Essay titles as such are not supplied, but can be constructed out of many of the panels. A key to the panels enables the reader to see at a glance what topics are dealt with in them.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("The book is intended to open onto a range of critical and interpretative literature on the prophets. Each chapter is supplied with lists of commentaries and other works, most of which are referred to in the chapter in question. Items marked with * are considered suitable as first ports of call, while others are more complex, or relate to specific issues.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("Above all the book is written in the belief that the prophets have important things to say to modern people. They are sometimes misunderstood, and, in church life, often neglected. That is nothing new for the prophets, as it was neglect that they themselves typically challenged in their hearers, rather than offering them ‘some new thing’. So I hope that this book will make a small contribution to their being heard clearly again.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("STUDYING THE PROPHETIC BOOKS")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("PROPHETS AND BOOKS")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xi"
    }
  }, [_vm._v("The study of the prophets can be illustrated by two very different passages from the prophetic books, one near the beginning and the other right at the end. The first is Isa. 6:1–13. In this, Isaiah has his famous vision of God as the heavenly king. It is the most dramatic picture of the prophet’s experience of God. Isaiah is overwhelmed by the vision of God’s glory, so that he is deeply aware of his own sin. Yet apparently it is this vision that inspires and motivates his whole ministry. The vision leads to ")]), _c('a', {
    attrs: {
      "id": "page_XII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("understanding, and to action. It is no surprise, then, that this passage has become the classic text for the idea of call itself. (It is one of the passages that are always read at ordination services in the Church of England.)")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("The second passage, much less famous, is Mal. 4:4–6. These words close the whole collection of the prophetic books. They exhort the people to remember the laws of Moses, and promises the return of ‘Elijah’ ‘before the great and terrible day of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("comes’. The law and the prophets stand together in these verses. The prophets stand alongside a ‘book’ (Moses’ law), and they have themselves become a book. The close of the prophetic section of the Old Testament announces the concept of ‘the law and the prophets’, a canon of Scripture.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("Our study of ‘the prophets’ lies between these two moments: the conviction of individuals that they had words from God that were urgent, for people then and there; and the collection of the prophets’ words for the benefit of new generations, well beyond their own time, right down to us who still read them and are challenged by them.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("In studying the prophets we cannot avoid the ‘book’. Indeed, ‘The Prophets’ in the title of this volume refers to a division of the canon of the Old Testament. When we look for Jeremiah, what we find is a book that tells us about Jeremiah and the things he did and said. The book was written (finally at least) by someone other than Jeremiah, for a time and place other than his own. And a number of the prophets are much more elusive than Jeremiah. (How often, when introducing one or other of the prophetic books, I have had to say: ‘Very little is known about x’!)")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("Even so, we will not be wrong to look for the prophet. Isaiah’s vision speaks of the central idea in the books: that God spoke to individuals and commissioned them to speak in turn.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("The relationship between ‘prophet’ and ‘book’ could be stated as a kind of problem or dilemma. Are we being teased with the promise of introductions to real people who finally elude us? Some studies focus so much on the book – in the guise of ‘the tradition’, or the ‘final form’ – that we lose the prophet altogether. Some regard the prophetic figures as the fictitious creations of the writers or communities who created the books. In my view, the opposite poles of prophet and book need not be treated as a problem. They are simply an inevitable part of the study before us. Both poles must be respected: the book because it is part of the canonical literature, and the prophet because his God-given message is the controlling idea in the book.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("What, then, are the key elements in studying the prophetic books? The following topics correspond to the headings we shall use in this volume when we come to each of them.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("THE PROPHET")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("Each chapter that follows will begin with some notes on the Date and Destination of the prophecy. This will ask questions about who the prophet was, the time in which he worked, and whom he spoke to. But what may we know about the prophets? We have several lines on this.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-001"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("Information in the individual books")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_vm._v("A number of the books give information about the prophets in their introductory headings, or superscriptions (e.g. Amos 1:1; Jer. 1:1–3) and elsewhere (Amos 7:14; Jer. 25:1–3; Zech. 1:1, 7; 7:1). These point to historical situations, and sometimes give details about the prophet’s family and his location in society (Jeremiah and Ezekiel were of priestly families). Some also tell about things they did (Amos 7:10–14; Isaiah 7—8). The Book of Jeremiah tells us a good deal about that prophet, including an incident that gives a clue about how his book came to be written (Jeremiah 36).")])]), _c('div', {
    staticClass: "encsimple",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xii"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page_XIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  }, [_vm._v("THE PROPHETS AS A SECTION OF THE OLD TESTAMENT CANON")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  }, [_vm._v("The books that bear the names of prophets form a distinct section of the Old Testament. This is true whether we are thinking of the Christian form of the Old Testament canon, or the Jewish form (the ‘Hebrew Bible’). The Hebrew Bible is usually divided into three sections: the Law (that is, the Pentateuch, or the Five Books of Moses), the Prophets and the Writings. In that division, the Prophets section is further divided into the Former Prophets (the Historical Books from Joshua to Kings, without Ruth), and the Latter Prophets. These Latter Prophets are the books that carry the names of particular prophets.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  }, [_vm._v("Christian Bibles broadly follow the order of the Greek Old Testament (known as the Septuagint, or LXX), and put these prophetic books at the end of the Old Testament. They also include two books that are omitted from the Hebrew form of the canon, namely Lamentations and Daniel. In the Hebrew form, these two (along with Ruth, Chronicles, Nehemiah, Ezra and Esther) belong in the Writings section. However, Lamentations was linked from a very early period with Jeremiah, and so was attached to that book in the canonical tradition found in LXX. Daniel is different in important ways from the other books in the prophetic collection. In scholarship it is usually classified as ‘apocalyptic’ rather than prophecy. (This is explained in the chapter on Daniel.) However, as it is like the prophets in its idea of an individual who receives revelations from God, and as it also has specific links with certain prophetic books (especially Jeremiah and Ezekiel), it too found its way into the prophets section of the canon as we have it in LXX, and so in Christian Bibles.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  }, [_vm._v("In "), _c('i', [_vm._v("Exploring the Old Testament ")]), _vm._v("we have adopted the divisions of the Christian Old Testament. This means, for example, that the volume on the Historical Books includes Ruth and Chronicles–Esther, and also that we deal with Lamentations and Daniel in the present volume. This choice has not been made for dogmatic reasons. But as we expect most of our readers to be using English Bibles, and the discussions presuppose no knowledge of Hebrew, it was the natural choice.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  }, [_vm._v("For the same reason we are using the term ‘Old Testament’. Of course this is a loaded term, as is the alternative, the Hebrew Bible. Strictly speaking, each of these names implies a claim to ‘own’ the book in question, either on the part of the Christian Church or the Jewish synagogue. It is not our intention in "), _c('i', [_vm._v("EOT ")]), _vm._v("to enter a debate about this, or to be dogmatic about it. And we hope that a Jewish reader could use our volumes for his or her own study. Yet "), _c('i', [_vm._v("EOT ")]), _vm._v("is a companion series to "), _c('i', [_vm._v("ENT")]), _vm._v(", and the primary target audience of both is students undertaking introductory courses on the Bible in broadly Christian contexts. In "), _c('i', [_vm._v("EOT ")]), _vm._v("this will emerge most clearly from those parts of our studies that reflect on the relationship between the Old and New Testaments.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiii"
    }
  }, [_vm._v("However, this kind of information varies from book to book. Some of the headings give little away (Joel 1:1; Nah. 1:1; Hab. 1:1; Mal. 1:1), and the prophets can remain rather shadowy. Even where much information seems to be given, scholars scrutinize it severely to see what it really tells. Since the information is patchy, it probably means that it is not felt to be greatly important in itself. When books do tell us details about a prophet’s life, it is likely that this is not for its own sake, but is part of the message of the book. This is ")]), _c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xiv"
    }
  }, [_vm._v("certainly true of Jeremiah 36, for example. (See below, ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#niv3-004"
    }
  }, [_vm._v("The prophets: Did they write?")]), _vm._v(" for more on Jeremiah 36. Some scholars used to talk of ‘biographical’ parts of Jeremiah, but that idea is no longer popular, because it is recognized that the writers did not have the same interest in people’s lives for their own sake as a modern reader might have).")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-002"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_vm._v("A broad Old Testament picture")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Apart from details about individual prophets, we have some glimpses of ‘the prophets’ as a body. The stories of Elisha, for example, speak of a group of ‘the sons of the prophets’ (just another way of saying ‘the prophets’), who live and work together (2 Kgs 4:1; 6:1). This suggests they were a recognizable group within society. A story of King Saul suggests that they engaged in ecstatic behaviour, under the influence of ‘the spirit of God’ (1 Sam. 10:9–13). King Ahab expected them to give him guidance when he was facing a big decision, such as whether to go to war (though Ahab was careful to choose which ones he listened to! 1 Kgs 22:6–8).")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The prophets as a body come to be regarded as the ones who called Israel to repent. This is how they appear in 2 Kgs 17:13, and there are echoes of this in the prophetic books themselves (Hos. 6:1; Jer. 3:1—4:4). They do not always appear in a good light, however. The story of Ahab already illustrates this (1 Kgs 22:24). And the prophetic books themselves sometimes portray ‘the prophets’ as unfaithful time-servers (e.g. Hos. 4:5; Amos 7:12–13; Jer. 23:9–40). This raises the question of how people might know the difference between a ‘true’ prophet and a ‘false’ one. The book of Jeremiah faces this problem directly. (It raises a quite different point for some scholars, namely whether the Old Testament has a unified view of ‘the prophets’. See the panel: "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-002"
    }
  }, [_vm._v("Digging deeper: Finding prophets")]), _vm._v(".)")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-003"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_vm._v("Sociology")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The biblical picture has been viewed by some recent scholarship from a particular angle. If we have only limited knowledge about individual prophets, perhaps we can find out something about their ‘social location’, that is, their place as a group or class within society. Fundamental to this concept is that prophets have ‘support groups’, that is groups that recognize the prophet as speaking authoritatively.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("To try to discover the prophets’ social location, scholars have observed how intermediaries are placed in other societies: do they, and their support groups, belong within the ‘establishment’ or outside it? Do they support or disturb the "), _c('i', [_vm._v("status quo")]), _vm._v("? Sociological studies have examined the different names used for prophets (‘prophet’, ‘seer’, ‘man of God’) and the ways in which they receive messages from God (especially in speech and vision). Variations in these respects have led some to find regional variations in the status and roles of prophets. Northern prophets, for example, have been thought to belong within a particular tradition in which the Mosaic covenant plays a significant governing role in their thought. Southern prophets like Isaiah, in contrast, are said to be influenced by ‘vision’, and this is related to a theology in which the temple, and the Davidic covenant, play an important role. (Wilson 1980, Petersen 1981 and Overholt 1996 are key studies on this topic.)")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One gain of this approach is to give a way of thinking about how a prophet’s words might originally have been preserved. If prophets had ‘support groups’ they will have wanted to preserve the authoritative words. One "), _c('a', {
    attrs: {
      "id": "page_XV"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xv"
    }
  }, [_vm._v("reason for this will have been to measure them against events, and have proof of their authenticity. It is clear that there was a great concern to know whether prophets’ words were true or false (Deut. 13; 18:20–22).")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xv"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xv"
    }
  }, [_vm._v("The question of how prophets’ words were preserved comes up differently with different prophets. See, for example, Isaiah: The composition of Isaiah 1—39.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-004"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xv"
    }
  }, [_vm._v("The prophets: Did they write?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xv"
    }
  }, [_vm._v("A special question in studying the prophets as individuals concerns how they gave their messages. Did they speak only, or did they also write? When they spoke, was it only in rather short poetic oracles, or could they also give more connected ‘sermonic’ speeches? (This last question comes up sharply in Jeremiah.) These questions are obviously related to the broader question of how accurate a picture of the prophet we are getting from the book.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xv"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xv"
    }
  }, [_vm._v("This is a fundamental issue in the study of the prophets, but there is surprisingly little agreement about it. The classic critical view was that prophets spoke in poetry, and the prosaic sections of their books were written only afterwards by less gifted disciples (proposed by B. Duhm 1901; see L. Stulman 1986 e.g. pp. 8–9). This view has been greatly contested in Jeremiah studies, where a number of scholars have argued that Jeremiah himself uttered the sermonic speeches (e.g. J. Bright; see on ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah: Critical Interpretation")]), _vm._v("). (The debate now seems to have reached an opposite extreme, with some saying the prophets were "), _c('i', [_vm._v("not ")]), _vm._v("prophets but "), _c('i', [_vm._v("poets")]), _vm._v("; see Finding prophets.) The idea that prophets were really poetic speakers went hand in hand with the idea that there was a gradual transition from authentic prophetic speech to written book.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("While some modern studies play down the connection between the prophet and the written word, others are finding evidence that points in the opposite direction. Referring to Ancient Near Eastern evidence, as well as evidence from writing in pre-exilic Israel and Judah, H. Barstad writes: ‘it is probable that prophecies were written down at a very early stage and later collected’ (1996, p. 124). Indeed, it is likely that prophecies, when uttered, would have been written down straight away. This may have been because it was regarded as important to record the message from God in the most accurate way possible, or to ensure it reached the right hearer (Barstad 1996, p. 123). (The same point has been made by A. R. Millard (1985) who also thinks the words would have remained unchanged when passed down from one generation to another. See also A. Malamat 1995, especially pp. 55–56.) R. P. Gordon also points to the significance of Ancient Near Eastern evidence in encouraging the search for the forms of prophecy that lie behind the books as we have them (1995, p. 602).")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One passage in our books throws light on this question. In Jeremiah 36 we read of how Jeremiah wrote his oracles on a scroll and had it read to King Jehoiakim. The king, who found Jeremiah’s words unwelcome, destroyed the scroll. Jeremiah responded by making another, with yet more of his words written on it. Does this episode tell us anything about how prophets "), _c('i', [_vm._v("usually ")]), _vm._v("had their words recorded? Or is this a unique incident, caused by the fact that Jeremiah was banned from going himself to the king at that time (Jer. 36:5–6)? It is impossible to be sure. What it does show is that the readers and hearers of Jeremiah would not have thought it strange that a prophet should write down his words "), _c('a', {
    attrs: {
      "id": "page_XVI"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvi"
    }
  }, [_vm._v("(Barstad 1996, pp. 125–26). We have one other instance of Jeremiah writing, in his letter to the exiles in Babylon (Jer. 29:4–28).")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvi"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvi"
    }
  }, [_vm._v("As we said a moment ago, the question of whether the prophets wrote is related to the question of how accurate a picture we have of them in their books. How much of what we read there actually came from them? Commentators vary greatly on this. Among those who attribute very little of the books to the prophets are O. Kaiser (see ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 1")]), _vm._v("), and R. P. Carroll (see "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2")]), _vm._v("). At the other end of the scale are, for example, J. A. Motyer, J. H. Hayes and S. A. Irvine (see "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 1")]), _vm._v(") and J. Bright (see "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2")]), _vm._v(").")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As commentators disagree over these basic issues, it follows that there is no scholarly consensus on who the prophets were or what they said or thought. What was the message of Jeremiah? Well, it depends whom you read. What some think is the message of Jeremiah others will attribute to later editors. An example of this diversity is the question of whether prophets were essentially preachers of judgement and doom, or whether they also urged repentance and held out the hope of salvation. (See "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah: Is prophecy predictable?")]), _vm._v(" See also the panel: "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic tradition: How oracles got into books")]), _vm._v(", in Critical Interpretation of Micah.)")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("FINDING PROPHETS")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For further discussion on the search for the prophet’s own words, see the debate between A. G. Auld, R. P. Carroll, H. G. M. Williamson, H. Barstad and T. Overholt in "), _c('i', [_vm._v("The Prophets: a Sheffield Reader ")]), _vm._v("(P. R. Davies ed.). Auld thinks that even the idea of ‘prophets’ as we find it in the books is late (post-exilic). Carroll supports this, adding that the Old Testament disagrees with itself over whether the ‘prophets’ were a good thing or a bad thing (pp. 43–44); prophets were really ‘poets’, ‘free spirits’, only tamed by an orthodox tradition (pp. 46–48). Williamson, Barstad and Overholt all make responses to this view. One response is that prophetic behaviour was well known in contemporary societies (Overholt). And it is also argued that Auld and Carroll have paid too little attention to Ancient Near Eastern parallels (Barstad, p. 113).")])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("THE BOOK")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We have spent some time thinking about how to find the person behind the book. It is now time to think a little about the book. The prophetic books are not just raw collections of disjointed sayings, but carefully constructed pieces of literature. In each of them we meet immediately a voice that is not the same as the prophet’s voice. This voice is heard in the superscriptions, the opening words of the book. Already here is a sign of organization, of someone who has set the prophet’s words in context and is writing for an audience that may be different from the prophet’s original audience.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In addition to superscriptions we also have narratives about the prophets and other characters (e.g. Hosea 1, 3; Isaiah 7—8; Jeremiah 32—44). The narratives and the sayings have been linked together, according to a sense of theme. For example, the story of Jeremiah redeeming the field of his cousin Hanamel is part of the ‘Book of Consolation’ (Jeremiah 30—33), which also contains Jeremiah’s sayings about the New Covenant (Jer. 31:31–34). The sayings and the story are on the theme of salvation, "), _c('a', {
    attrs: {
      "id": "page_XVII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  }, [_vm._v("which is predominant in this part of the book of Jeremiah. Similarly, sayings themselves have often been organized according to a definite structural plan. This is very clear in Isaiah 1—12, where sayings of judgement and salvation alternate. All these features show that someone has thought about what the message of the prophet adds up to, how it fits, not only into his own life, but into the life of the community in which he ministered.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  }, [_vm._v("There are further signs of how sayings have been gathered into a book. The two different forms of Jeremiah (Hebrew MT and Greek LXX) show two different attempts to shape the memory of Jeremiah’s life and work into a book. The overlapping of material between books is another indicator: between prophetic books (Isa. 2:2–4; Mic. 4:1–4), and between prophetic books and other types of book (Isaiah 36—39 and 2 Kings 18—20; Jeremiah 52 and 2 Kings 25). This shows a conscious use of existing material. (Both Isaiah 36—39 and Jeremiah 52 present versions of the events in question that are adapted to the interests of the respective prophetic books.) Finally, there are editorial comments, additions, and linkages, e.g. Mal. 4:4–6 [3:19–24]; Isa. 2:5; Hos.14:9 (with the last of these compare Psalm 1 as a ‘wisdom’ superscription to the Book of Psalms).")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-005"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  }, [_vm._v("The formation of the book")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  }, [_vm._v("Can we discover the process by which the words of the prophet came to be collected in the book? A good deal of scholarship on the prophets has concerned itself with this question. The same means have been applied to it as to other parts of the Old Testament, especially literary criticism, form criticism, and redaction criticism. Examples of these will be given in the course of the present book. Here we will give some examples and definitions.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  }, [_c('b', [_vm._v("Literary criticism ")]), _vm._v("In Old Testament scholarship until recently, literary criticism meant noticing such things as inconsistency, incoherence, and differences of style, in order to separate the stages in a book’s composition, and find its original form. This method of studying biblical books was at the forefront of scholarship in the modern period, that is, from the late nineteenth century on. In Pentateuchal studies, Julius Wellhausen formulated the well-known four-document theory (JEDP; see G. J. Wenham in "), _c('i', [_vm._v("EOT: The Pentateuch")]), _vm._v(").")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xvii"
    }
  }, [_vm._v("In the prophets, the leading name was Bernhard Duhm, whose commentary on Isaiah in 1892 was ‘the first genuinely modern commentary on a prophetic book’ (Blenkinsopp 1984, p. 28). Duhm wanted to separate out the genuine words of the prophet from later expansions, which he thought inferior. For Duhm, this was not a purely academic exercise, for he had a real religious interest in doing this. He thought that if he could find the true words of the prophet he would also uncover his religious experience, which he believed was a deep and true experience of God. This knowledge of God was bound up, in Duhm’s view, with the poetic expression, which he thought marked true prophecy. Literary criticism in its heyday, therefore, had a profound religious motivation, at least for some of its advocates. (J. Skinner’s study of Jeremiah (see ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2")]), _vm._v(") is a good example of this in English.)")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In our own study, the literary critical interest comes out most strongly in Jeremiah, where the prose-sermons were attributed to a different source from the poetic oracles. "), _c('a', {
    attrs: {
      "id": "page_XVIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xviii"
    }
  }, [_vm._v("Narratives about the prophet were assigned to yet another source. (See ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah: Critical Interpretation")]), _vm._v(".)")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The problems with literary criticism are, first, that it made certain assumptions about the form of ‘authentic’ prophecy, which may not hold true, and second that it devalues much of what we find in the prophetic books.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  }, [_c('b', [_vm._v("Form criticism ")]), _vm._v("Form criticism is a study of forms of speech as used in specific settings. It was applied with great success to the Psalms, where a setting could be readily identified (Israel’s worship), and where a number of recurring elements suggested that Psalms could be classified into a small number of types.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  }, [_vm._v("In the prophets, the search for typical forms took the study of prophetic speech much further than literary criticism had done. The pioneer of form criticism, H. Gunkel, thought prophets uttered ‘vision-reports’ (reports about their experiences of having visions), and spoke words of threat and promise (Tucker 1971, pp. 55–56). The most influential study of prophetic forms has been C. Westermann’s (1991, pp. 90–98). He finds three types: accounts (including vision reports), speeches and prayers. The speeches are the most important. These divide mainly into announcements of judgement or salvation, and the underlying idea is of pronouncements by a messenger (Westermann 1991, pp. 93, 98–128). The effect of this is to claim that the prophetic speeches merely announce something that has already been decided. When the prophet announces God’s judgement, not only is the judgement inevitable, but the announcement itself has a certain power to set it in motion (Westermann 1991, pp. 65–67). This is different from the idea of a ‘threat’, which could imply a chance to avoid the judgement by repenting.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  }, [_vm._v("The strength of form criticism in the prophets is in the ‘messenger’-concept, which recognizes the force of the words spoken. Westermann rightly sees that no distinction can be made between the word of God and the word of the prophet (Westermann 1991, pp. 94–95). We will come back to this under ‘Rhetorical Intention’ below. The weakness is perhaps in its idea that classical forms of the announcements are brief (Westermann 1991, p. 105), which sets off again on a hunt for the ‘original’ and therefore (like literary criticism) thinks of some of the writing in the prophetic books as secondary and in a sense a degeneration.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  }, [_c('b', [_vm._v("Redaction criticism ")]), _vm._v("Redaction criticism is the prevailing type of criticism in modern scholarly writing on the prophets. It is different from literary and form criticism because it is interested in principle in the formation of the books up to their final form. It recognizes that the words of prophets have been recast into new contexts, and so given new meanings. And it assumes that these new contexts and meanings are as important and interesting as any original ones. Redaction criticism has two aspects, therefore: the study of the stages of a book’s growth, and the study of the finished work itself, with all the inner relationships between its parts that have been produced by the process.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "criticism"
    }
  }, [_vm._v("Most modern studies of prophetic books assume that the book has undergone a complicated process of growth. With a pre-exilic prophet this may mean that his prophecies were first collected together by people rather close to him in time, that the ")]), _c('a', {
    attrs: {
      "id": "page_XIX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xix"
    }
  }, [_vm._v("book was then formed into a shape resembling what we now have in the time of King Josiah or the exile, and finally was filled out by still more expansions (this is the account of Collins 1993, pp. 15–16). Another advocate of redaction criticism is R. E. Clements, who writes:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant last"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xix"
    }
  }, [_vm._v("Even so complex a composition as the book of Isaiah, which evidently took centuries to reach its final form, shows evidence that, through its many stages of growth, intentional connections and interrelationships between the parts were planned (Clements 1996, p. 204).")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xix"
    }
  }, [_vm._v("The growth of books, then, is not haphazard, but comes out of careful theological reflection. This means that there is an important connection between the process of growth and the interpretation of the book in its final form. Because the process of growth was governed by theological aims, the finished book offers possibilities for theological interpretation by the comparison of its various parts together (Clements 1996). We have already noticed some of the ways in which the raw materials of prophecy have been formed together into books, for example, the careful arrangement of the prophecies in Isaiah 1—12, where sayings of judgement and salvation alternate, making us think about how those two kinds of message might relate to each other.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xix"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xix"
    }
  }, [_vm._v("Redaction criticism, therefore, is an important attempt to account for the ‘book’-characteristics of prophecy that we noticed at the beginning of this section. If as readers of the prophetic books we think that they – especially the larger ones – are rambling and shapeless, redaction criticism encourages us to look beyond our first impressions to think about their message as a whole.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xix"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xix"
    }
  }, [_vm._v("Redaction criticism leaves certain questions unanswered, such as the precise means by which smaller units were gradually enlarged into recognizable blocks and finally books. We will meet a number of theories about this in our study (such as W. McKane’s ‘rolling corpus’ in Jeremiah; and H. G. M. Williamson’s belief that Deutero-Isaiah shaped the whole block of Isaiah 2—55). Some think the cult (the institutions of Israel’s worship life) was the vehicle in which the books were carried as they developed (Coggins 1996, p. 81). See also the panel: ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Was there an Ezekiel school?")]), _vm._v(" in Critical Interpretation of Ezekiel.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-006"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("THEOLOGICAL THEMES")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This section looks for the theological contribution made by the prophetic book in question. In thinking about prophetic theology, we are faced again with the question of prophet or book: are we looking for the theology of the prophet himself, or the theology of the book? The theological themes that we find are, of course, found in the "), _c('i', [_vm._v("book")]), _vm._v(", or even in the books as a collection. R. E. Clements probably expresses the most common modern view when he says that this is where we should look for the theological contribution of the ‘prophets’:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant last"
  }, [_vm._v("It is our contention, however, that it was not until a whole corpus of prophetic sayings came into being as a written record that it became possible and necessary to look for a larger degree of coherence and consistency in their implied disclosure of the divine nature and a genuine theology became possible (Clements 1986, p. 206).")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("However, the books give us a picture of prophets who were themselves theologically motivated. They believed they were commissioned by the God of Israel (not "), _c('a', {
    attrs: {
      "id": "page_XX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  }, [_vm._v("another god) to speak his word. And we saw that some scholars at least thought that the books preserve the prophets’ words accurately. Prophets plainly had strong beliefs about God and were prepared to take enormous risks in order to declare them.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  }, [_vm._v("What were those ideas? If we were to identify the main thrusts of the prophets’ theology, it would probably be twofold: an opposition to the worship of gods other than Yahweh; and a demand for justice and righteousness in the community that laid claim to being the chosen people.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  }, [_vm._v("Yet we do not have to suppose that their theology was unique. At one time it was thought that the prophets were the true founders of Israelite religion in its best form, or ‘ethical monotheism’, as some put it. When Wellhausen famously put the ‘Law’ after the Prophets, reversing the traditional order (Moses first, then prophets), he was promoting that kind of idea. The prophets spoke for a religion of the heart; the law debased this into a preoccupation with rituals and legalism. (See Gordon 1995, pp. 4–5 for a brief account of this.) But those days are long gone. Nowadays it is recognized that the relationships between the prophetic books and the theological traditions of Israel are complex.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  }, [_vm._v("If the prophets are distinctive, it will not be at the level of what they believed, in and of itself. In the following, we will notice briefly some relationships that prophetic theology has with other parts of the Old Testament.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-006"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  }, [_vm._v("The Prophets and other OT literature")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xx"
    }
  }, [_c('b', [_vm._v("Prophets and Wisdom ")]), _vm._v("For example, the prophets were once sharply distinguished from Israel’s Wisdom traditions. Wisdom was universal, while the prophets were narrowly focused on Israel’s own religion and special status. But it is clear that prophets and Wisdom share important ")]), _c('a', {
    attrs: {
      "id": "page_XXI"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxi"
    }
  }, [_vm._v("emphases. For example, prophets preach that people should seek justice and righteousness (Isa. 1:26–28; Amos 5:24); and this is also a concern of Proverbs (Prov. 16:8, 11–13). Moreover, this concern is based on very similar beliefs about the world. Prophets and Wisdom teachers alike believe that right behaviour is related to the created order of the world. This is well expressed by Barton (see ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 1")]), _vm._v(") ("), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#renv-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-003"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("PROPHECY AND WISDOM")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The comparison of prophecy and Wisdom is complicated by a number of factors. For example, is the picture of Wisdom as we have it in Proverbs true to Wisdom’s origins, or has it been conformed to an ‘orthodox’, Yahwistic theology? Was there a distinct class of ‘sages’? Jer. 18:18 suggests that the ‘wise’ were a group who could be easily distinguished from prophets and priests. If so, what did they believe? J. L. Crenshaw speaks of a sceptical Wisdom, which was at last ‘wedded’ to Yahwism (1981, p. 24). On the other hand there is the familiar problem of deciding what prophets actually said and thought.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One issue, which is sometimes said to put a difference between prophets and Wisdom, is ‘epistemology’, that is, how they ‘knew’ God’s will. The ‘wise’ attached importance to teaching, learning, counsel, or what we might call working things out (see the range of vocabulary used for these things in Prov. 1:2–6). Prophets, on the other hand, had special revelations from God. This is an overstatement, however. The ‘wise’ knew that true knowledge began in knowing God (Prov. 1:7). And prophets, on the other hand, could rely on ‘natural’ intelligence and common sense (e.g. Isa. 28:23–39; Amos 3:3–8). See Williamson, ‘Isaiah and the Wise’, for his careful analysis of how Isaiah agrees and disagrees with the Wise on this subject. Compare this with the essays of A. Macintosh and W. McKane in the same volume. What do you conclude from these about the relation of prophets to the Wisdom traditions?")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Prophets and Law ")]), _vm._v("The idea that Law could simply be dated later than prophecy has also proved hard to maintain. Most critical scholarship allows that at least some Pentateuchal laws (e.g. Exod. 20:22—23:10) are relatively early. They share with the prophets a belief in the connection between worship and right behaviour, and also a concern for justice that goes beyond the letter of the law (e.g. Exod. 22:21–24 [20-23]). Furthermore, comparisons between the major blocks of the Old Testament (such as Law and Prophets) are now usually in the context of redaction criticism (which we have discussed above). This means that important links are often noticed across the blocks. For example, Jeremiah’s metaphor of a ‘circumcision of the heart’ (Jer. 4:4) is also found twice in Deuteronomy (Deut. 10:16; 30:6). The idea of ‘Deuteronomistic’ editing of the prophetic books makes it impossible to think of a rigid division between the blocks. (For the theory of the Deuteronomistic editing of Jeremiah, see "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Interpretation of Jeremiah")]), _vm._v(".)")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Prophets and Deuteronomy ")]), _vm._v("How the prophets relate to Deuteronomy is a special and complicated question. A critical view is expressed by J. Blenkinsopp, who sees an important difference between prophets and Deuteronomy. He thinks that Deut. 34:10–12 carefully places the revelation given to Moses on a higher level than all prophetic teaching that came after him:")]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg type_1"
  }, [_vm._v("Never since has there arisen a prophet in Israel like Moses, whom the")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" knew face to face.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Balancing this text, however, is Deut. 18:15–18, which leads us to expect that there "), _c('i', [_vm._v("will ")]), _vm._v("be other prophets like Moses. Blenkinsopp thinks Deut. 34:10–12 intends to guard against a misunderstanding of that text (1984, pp. 189–90). However, it is not clear that this is the intention of Deut. 34:10–12. Other texts mark out individuals as greater than all others before or since, and they have an element of exaggeration in them (see 2 Kgs 18:5, about Hezekiah; then 2 Kgs 23:25 about Josiah – can both of these texts be literally true?). The canonical prophets may be viewed as being in continuity with Moses.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The issue pinpointed by Blenkinsopp, however, is the one with which we began: that the work of prophets is enshrined in books, and the prophetic legacy stands alongside that of Moses. Was this the work of the deuteronomists, as many think? It is an open question whether it was such a group, or if others were involved in carrying and finalizing the prophets’ words. In any case, it is extraordinarily difficult to extricate deuteronomic theology from that of the prophets. Many have thought, indeed, that Deuteronomy was the work of prophets. (Hosea is often held to be the specific source of Deuteronomic theology; e.g. Nicholson 1986.) Others think, in contrast, that it was Deuteronomy that exerted influence on them (e.g. Andersen and Freedman in their commentaries on Hosea and Amos; and I have argued likewise in my commentary on Deuteronomy).")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XXII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxii"
    }
  }, [_c('b', [_vm._v("Prophets and Psalms ")]), _vm._v("We noticed a moment ago that an older view of the prophets put them at odds with the formal religion of Israel’s temple and its personnel. This is only one side of a story, however, for a number of Old Testament scholars have pointed out close connections between prophecy and cult. Prophets and Psalms share major themes. For example, Psalms 40 and 50 contain severe criticism of sacrificial worship, very like what we find in Isa. 1:10–17; Amos 5:20–25; Mic. 6:6–8. Psalms also have criticism of Israel’s past disobedience (e.g. Psalms 78; 106) and call worshippers to renewed faith and obedience (e.g. Psalms 15; 19). On the other hand, prophets often use language that is ‘Psalmic’. The best example is Jeremiah’s ‘Confessions’ (see ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#niv2-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah: Theological Themes: The Individual")]), _vm._v("). Other examples are in Isaiah 40—55 and Habakkuk 3.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For reasons like this some have thought that prophets operated inside the cult, and have spoken of ‘cult-prophets’. Almost certainly, however, there was not a separate class of prophets who operated exclusively within the official worship of Israel. It is important to notice that prophets "), _c('i', [_vm._v("might ")]), _vm._v("work in that sphere, and were not absolutely opposed to it. The official worship, after all, carried the central traditions of Israel, which the prophets were also interested in maintaining.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-007"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_vm._v("The distinctiveness of the Prophets")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A prophetic tradition? ")]), _vm._v("Another approach to the question of whether the prophets have a special, distinctive theology is to consider links between the various prophets. There are clear similarities between certain prophets. For example, Hosea is so like Jeremiah in certain respects that Jeremiah is often thought to have been influenced by the earlier prophet (e.g. the call to repent, the metaphor of prostitution for Israel’s unfaithfulness to Yahweh). Jeremiah in turn then influenced Ezekiel.")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-004"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("PROPHETS AND PSALMS")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The classic works in English are two books by A. R. Johnson, who thought that the ‘prophets’ ("), _c('i', [_vm._v("nebi’im")]), _vm._v(") as a group in early Israel were cultic prophets, and that many Psalms were composed by them. The idea was used among other things to explain why Psalms of lament often changed suddenly from a mood of lamentation to one of confidence and praise (e.g. Pss 6:8–10 [9–11]; 13:5–6 [6]). The change may have been caused by a prophetic word given in the worship, but not recorded in the Psalm. For a short review of Johnson and others on this topic, see Bellinger 1984, pp. 9–21. A partial acceptance of the theory is found in H. H. Rowley 1967, pp. 144–75.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This theory as a whole is attractive, but cannot be proved. If a ‘canonical’ prophet sometimes uses language that looks like Psalm-language, this may only mean that he has imitated that style for his own purposes.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The similarities between prophets have been studied carefully by a number of scholars.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("R. R. Wilson highlighted the links between northern prophets, though he included Jeremiah in his ‘Ephraimite tradition’ (1980). Holladay has cast the net more broadly, tracing influences on Jeremiah through various parts of the Old Testament including a number of prophets, both northern and southern (Holladay 1989 (see chapter 2), pp. 35–70). A recent study devoted to this subject is H. Lallemande Winkel, "), _c('i', [_vm._v("Jeremiah in Prophetic Tradition")]), _vm._v(". "), _c('a', {
    attrs: {
      "id": "page_XXIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  }, [_vm._v("If there is a ‘prophetic tradition’, does it mean that the prophets had a distinctive theology after all? Our brief review of their relationship with other parts of the Old Testament and Israel’s religious life does not suggest this. Prophets shared core beliefs with others in Israel, whose thinking has come to expression in other parts of the Old Testament. The echoes from one prophet to another (that give rise to the idea of a prophetic tradition) are only partly theological. They also consist in linguistic style and patterns of behaviour.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  }, [_vm._v("However, we can pursue the question of theological distinctiveness in another way, by considering patterns in the prophetic books. When we observe this pattern, we shall see that the prophetic books do something with Israel’s theological tradition that no other part of the canon does.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  }, [_c('b', [_vm._v("Patterns in the prophetic books: The ‘story’ in the books ")]), _vm._v("In the Theological Themes section of each of the following chapters, the aim is to try to draw out the special emphases of each book, without undue repetition. Obviously the prophets all have fundamental things in common, such as the call to worship Yahweh, not other gods, and to do so sincerely; the judgement of God on sin, and his salvation of the people after a time of punishment. Some have particular things in common with others (e.g. Ezekiel and Haggai on the temple). Often it is possible to see some special nuance of a theme (the extension of the ‘covenant’ to the nations in Isaiah 40—55, for example).")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  }, [_vm._v("Certain important themes do emerge regularly, however. Indeed, it is possible to think of the theology of the prophetic books in a kind of ‘story’. I do not mean a story that is told on the surface of the page, of course (there are stories of that sort "), _c('i', [_vm._v("in ")]), _vm._v("the books, e.g. when Jeremiah buys a field, Jeremiah 32; or when Hosea is told to marry a woman of poor reputation and have children with her, Hosea 1). Rather, it is a story that is implied beneath the surface. It may alternatively be called a ‘pattern’ in the structuring of the books. The typical feature in the pattern is that announcements of judgement are followed by announcements of salvation. The logic of this is that after judgement has come, Yahweh is free to act again in favour to his people, and make a new beginning with them. This patterning is often attributed to a common editing process of the prophetic books (see Clements 1977). Yet it may also be related to the prophets’ actual thought. The ‘story’ they tell is grounded in their belief that Yahweh will finally bless his chosen people. The sequence of judgement and blessing is a way of thinking about the covenantal curses and blessings (Deuteronomy 28), worked out in history. The same idea is present in Deut. 30:1–10. (This relates, incidentally, to how we judge the ‘authenticity’ of such passages as Amos 9:11–15; see on that text.)")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiii"
    }
  }, [_vm._v("The ‘story’ is spelt out in more detail for Isaiah in Isaiah: Theological Themes: The ‘story’ behind the book, and the following passage, Zion, city of God. It covers God’s creation of the world, his election and salvation of Israel, their establishment in their land, the coming of Kings David and Solomon and the temple, and the loss of land as a judgement because of sin. Then it continues into the future, with expectations of deliverance. God will first restore Israel to the land itself, but will lead on in the end to a greater salvation, which paradoxically involves both victory over the nations and the nations’ salvation. (It would be good to read those sections at this point, as what is ")]), _c('a', {
    attrs: {
      "id": "page_XXIV"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("said there is more broadly relevant. However, it cannot be carried over wholesale to all the other prophets. For example, Hosea’s ‘story’ differs because the Jerusalem traditions play no part there.)")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("To call this set of assumptions a ‘story’ is not to reduce its importance. On the contrary, it is to try to understand what made the prophets and their hearers tick. Why did Amos or Micah or Zechariah bother to do it? The answer is that they believed God had worked in Israel’s life in the past and would do so again in the future. The greatest imaginable things were at stake. The people of Yahweh could either hear and obey him, and enter into the life that he held out for them, or they could look for their well-being elsewhere (in other gods, or in throwing in their lot with the ‘superpowers’ of the day), and lose their part in God’s intention to bless them.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-008"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("Patterns in the prophetic books: The shifting lens – the meaning of ‘Israel’")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("One of the striking things is the subtle ways in which the story changes. In a sense this is a simple and natural shift of the lens. The later books (Haggai, Zechariah, Malachi) no longer look forward to judgement and exile, but back on it. Even so, they still believe in a greater salvation ahead, so the basic pattern does not change. More important is the way in which concepts such as ‘covenant’ and even ‘Israel’ change. As we have just noted, ‘covenant’ in Isaiah 40—55 changes to include other nations. The disturbing effect of that for Israelites was probably also felt by those who read Jonah, and heard of a repentance by the Ninevites, and how Yahweh decided not to judge them after all.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("Similarly, when Israelites heard the name ‘Israel’, it would have brought to mind for them the memory of their election and salvation. ‘Israel’ was saved from slavery in Egypt, and brought into its own land. Other nations were driven out of Canaan to allow this to happen (Joshua). But what does ‘Israel’ mean when a large part of the nation has been taken away into exile in Assyria, to be mixed up hopelessly with other peoples of the Assyrian empire and never heard of again? This huge event in Israel’s life meant the loss, not of a small part of the whole, but the ten tribes, out of twelve, that made up the northern kingdom. In the Books of Kings that part itself was simply called ‘Israel’ (the southern two tribes were called Judah).")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("The story of the prophetic books involves re-thinking who ‘Israel’ is. The prophets sometimes speak of a ‘remnant’ in order to show how the story of Israel is advancing (Isa. 10:20–23; Jer. 5:10; Joel 2:32 [3:5]). They also sometimes picture a reunion of Israel, north and south, in a way that cannot be meant in a plain historical sense (Ezek. 37: 15–17). In other words, ‘Israel’ is redefined in the prophets as a people that remains faithful to Yahweh. That people, however, is still heir to all the ancient promises that first called a people out of Egypt.")])]), _c('div', {
    staticClass: "encsimple",
    attrs: {
      "id": "enc-005"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_c('span', [_vm._v("MORE ON ‘ISRAEL’")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("The point just made has obvious implications for how we understand the term ‘Israel’ today. If the name ‘Israel’ can keep changing what it refers to, and is qualified in the way that we have seen, in what sense may it refer to modern ‘Israel’? Do ‘Israelite’ and ‘Israeli’ mean the same thing?")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxiv"
    }
  }, [_vm._v("The point is considered further in two panels: in chapter 1, ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How can the exiles be ‘Israel’?")]), _vm._v(" and, in chapter 2, "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel’s return to its land")]), _vm._v(".")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XXV"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxv"
    }
  }, [_vm._v("It is in this way, finally, that the prophetic books make their distinctive mark on the Old Testament. They project faithful Israel into a future that is still not realized at the end of the Old Testament period. In the prophets one can speak of ‘eschatology’, that is, a theology of the ‘end’. This emerges in various ways in our books, as we shall see.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxv"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxv"
    }
  }, [_vm._v("Eschatology is often thought to be the special province of ‘apocalyptic’. However, eschatology is not confined to apocalyptic, nor is it the essential characteristic of it (see the panel on ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apocalyptic")]), _vm._v(" in the chapter on Daniel). However, the fact that Daniel is included in the form of the canon in Christian Bibles shows that a concern with the future is a direction set by the prophetic books. Eschatology in the Prophets means looking forward to greater fulfilments of God’s promises than the people experiences in the present.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("RHETORICAL INTENTION: PROPHETIC ‘ART’")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The prophets may not have been original in their theology, but they are unparalleled in the Old Testament for their power to "), _c('i', [_vm._v("persuade")]), _vm._v(". I have included the topic Rhetorical Intention in the treatment of each prophetic book because it helps us to think about how the prophets aimed to make an impact on their hearers, and also about how the books make an impact on their readers.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("‘Rhetorical criticism’ is an important recent development, not only for the prophets, but for all the biblical literature. But it is perhaps especially important for the prophets. The type of rhetorical analysis I mean is more than just stylistic analysis (though the term was once used for this; Muilenburg 1969). Instead, it is the study of how language is used in order to persuade people to a point of view (see Patrick and Scult 1990, for an important application of the method to biblical studies).")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Defined in this way, every aspect of prophetic language comes into the frame of our study. Why did the prophets so often speak in poetic forms? Part of the answer is no doubt that the sublime language of poetry was thought suitable to speak about God. (See the panel: "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The song of the vineyard as poetry")]), _vm._v(", at Isa. 5:1–7.) But in addition, the prophets used their poetry to take hold of the hearer’s attention, to challenge and surprise (Amos’s turning of the Oracles Against the Nations form on Israel and Judah is a well known example of this; Amos 2:4–8). The prophets’ "), _c('i', [_vm._v("art ")]), _vm._v("is not an optional extra to their message, but essential to it. We might say that it is not just for aesthetic purposes, but we must qualify this by saying that its aesthetic qualities – its rhythms, alliterations, onomatopoeias, symbolism – are part of its attractiveness. Unfortunately only some of these features can be represented in translation. But these techniques of communication are very important for an understanding of the prophets’ mission. (In R. P. Gordon’s collection of important essays on prophecy, by far the largest section is entitled ‘The Art of Prophecy’; Gordon 1995.)")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The art of the prophets is not just their poetry, but also their narrative, their use of metaphor, their rhetorical use of dialogue (Haggai, Malachi), their symbolic actions (see panel on "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic symbolic actions")]), _vm._v(" at Ezek. 4:1—7:27). That these were used for effect is clear because they were sometimes extreme and shocking (Hosea’s marriage to a prostitute, Hosea 1; Jeremiah’s metaphor of divorce to proclaim the end of the relationship between Yahweh and Israel; Jer. 3:1–5; Ezekiel’s pushing of the prostitute "), _c('a', {
    attrs: {
      "id": "page_XXVI"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("image to lurid extremes, Ezekiel 16; 23). No holds were barred in the prophets’ methods of persuasion.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("Rhetorical criticism is concerned with speakers or writers and their ‘audiences’. We have already discovered, however, that it is not easy to pin down the prophets and their original audiences. So we have to think more broadly about who is persuading whom. We have already seen that the form in which we now have the prophetic books is an important level of our study of the prophets. This is true for the rhetoric of the books as much for their theology. The book itself, as a record and memory of the prophet’s words, has its own audience, which might be quite different from the prophet’s. That is, the words of Amos take on a quite new significance when read by (or to) an audience in the exile in Babylon. Nor is there only one possible audience of the final form of the book, but many – including modern audiences and readers of the books. So the analysis of the book’s rhetorical power is rather open-ended. Yet it will aim to show how the books can go on being effective in new situations.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-009"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("Art and the divine word")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("The prophets’ art in their speech can be explained at a deeper level. For it demonstrates effectively the central importance of the Word of God in their thought. I said a moment ago that the prophets used poetry because it was an appropriate way to speak about God. Of course, the biblical witness is not that poetry is the only appropriate means of speaking about God (since the Bible also includes laws, narratives, letters and other forms). But poetry has a capacity both to speak about things that are very familiar, and to lead the imagination on to new ways of thinking and understanding. Poems do not give cut and dried meanings, but are often open to several interpretations. It is in this openness that the reader or hearer is invited to think about God.")])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-006"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_c('span', [_vm._v("Digging deeper:")])])]), _c('p', {
    staticClass: "enc_stit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_c('span', [_vm._v("POETRY, METAPHOR AND THEOLOGY")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("For more on poetry and theology see Miller (2000) and Sherwood (2001). Steiner (1989) is a sophisticated philosophical treatment of poetry and transcendence.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("For definitions of metaphor and related terms, see Cotterell and Turner 1989, pp. 299–303; and on metaphor and theology, see Soskice 1995.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("There is a further reflection on metaphor below at Joel: Rhetorical Intention.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvi"
    }
  }, [_vm._v("To say that prophetic speech is rhetoric, then, is to make a theological point. Prophets speak the word of God, and they do so in ways that are appropriate to their subject (God and the heavenly realm). The same ways are also suitable for calling people back to God. At this point we may notice a connection with what we said above about prophetic speech as the speech of a messenger (when we discussed Westermann on form criticism). Rhetorical criticism applied to the prophets confirms that that idea is helpful. However, rhetorical criticism takes us further in thinking about how speech becomes effective. In contrast to Westermann’s view, a pronouncement of judgement may well have the effect of turning people from their sin, and so avoiding the judgement that was pronounced. The best (perhaps only) ")]), _c('a', {
    attrs: {
      "id": "page_XXVII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("example of this in the prophetic corpus is the book of Jonah, where the people of Nineveh repent. God’s ‘rhetorical intention’ was presumably fulfilled in that repentance – even if Jonah’s was not!")])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-007"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_c('span', [_vm._v("Think about")])])]), _c('p', {
    staticClass: "enc_stit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_c('span', [_vm._v("RHETORIC AND SPEECH-ACTS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("Rhetorical criticism has much in common with ‘speech-act theory’, which analyses language in terms of its power to act or ‘perform’. The classic is J. L. Austin’s "), _c('i', [_vm._v("How to Do Things With Words ")]), _vm._v("(1962). It has been applied to the way in which God may be said to ‘speak’ in Wolterstorff’s philosophical study, "), _c('i', [_vm._v("Divine Discourse")]), _vm._v(". Wolterstorff also uses a form of the ‘messenger’ (or ‘ambassador’) metaphor. Further interesting reflections on the human and divine word are found in McKane 1995, e.g. pp. 14–22.")])])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("CANONICAL CONTEXT")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("This final division of our treatment of each prophetic book aims to say something about how the book in question stands in relation to the wider canon, both Old and New Testaments. For many readers, this may be the goal of their study of the books. It is important to consider what exactly might be meant by this idea.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("The canonical dimension of the study of the Old Testament was put on the academic map by Brevard Childs in several publications, especially his "), _c('i', [_vm._v("Introduction to the Old Testament as Scripture ")]), _vm._v("(1979). Childs appeared to mean several different things by canonical interpretation. Foremost was a focus on the individual biblical book in the form in which it was ‘canonized’. His concern in this was to get beyond historical criticism to theological interpretation of the final text. He believed that the theological meaning of the book, as it was received by the believing community, was more important than other meanings that might be discovered at different stages in the book’s composition.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("In my treatment of the individual books in this volume, I have placed most emphasis on the final form. For example, the book of Isaiah is considered as a single book, because that is the canonical form in which we have it. (Some introductions to the prophets deal with Isaiah 1—39 separately from chs 40—55 and 56—66; e.g. von Rad; Koch (see chapter 1).) The different original settings of parts of the book are also dealt with. But the main level of interpretation is of the book in its final form. I have followed Childs’ lead in this respect, therefore.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("However, that is not the main focus of this section of the discussion of each book. A further level of canonical meaning is how the book related to its Old and New Testament contexts, and that is where our interest lies here. This too has a number of levels, however. First, each book has immediate neighbours in the canon, and sometimes it seems as if the order of the books has been deliberately arranged in order to bring these out. For example, in Joel 3:16 [4:16] we read:")])]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg type_1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("roars from Zion")])]), _c('p', {
    staticClass: "verslg type_2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("And utters his voice from Jerusalem.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxvii"
    }
  }, [_vm._v("And this same phrase then appears again in Amos 1:2. In English Bibles this is only a few verses later, and the effect is to produce a catchword link between the two books. The force of the saying in each case is different, as in Joel it heralds sayings about the safety of Judah, while in Amos it leads into ")]), _c('a', {
    attrs: {
      "id": "page_XXVIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("judgement. It may be that Joel has been placed first in order to soften the effect of Amos in the reading of the Book of the Twelve as a whole. (The order of the Book of the Twelve in English Bibles follows the Hebrew Bible. In LXX, Amos and Joel are separated by several books, so this point is weaker. However, in one canonical tradition at least, it seems that someone has had an overview of the books that has influenced how they now appear.)")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("Second, the individual books have a context in the prophetic corpus as a whole. Another well-known saying has an echo of a different sort. In Isa. 2:4 we read:")])]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("They shall beat their swords into ploughshares")])]), _c('p', {
    staticClass: "verslg type_1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("And their spears into pruning-hooks.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("But in Joel 3:10 [4:10]:")])]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg type_1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("Beat your ploughshares into swords,")])]), _c('p', {
    staticClass: "verslg type_2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("And your pruning hooks into spears.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxviii"
    }
  }, [_vm._v("The distance between Isaiah and Joel in the canonical order is not close, but even so the echo is unmistakable (see also ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#chap-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book of the Twelve")]), _vm._v("). The effect is to encourage reflection on how Yahweh’s final peace relates to his final war and victory.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Third, the prophetic books have a context in the Old Testament as a whole. The relationships we have noticed between them and the Pentateuch and Psalms and other sections of the canon set up echoes, which can be fruitfully explored. For example, Jeremiah’s New Covenant must be understood against the background of the covenantal traditions of the Pentateuch.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Finally, the prophets can be heard in the context of the New Testament (the New Covenant serves as an example of this also). In regard to all these levels it is possible to try to hear echoes from the particular book across the larger canonical context. How the book contributes to the theology of the whole Bible is never easy to state in any conclusive way. It is not a simple matter of lining one up against another and seeing where it might have something different. The point is rather to let the books have a kind of conversation with each other. The meaning of the particular book, therefore, is not finally decided in isolation, but only as a part of a whole. This seems to me to be the most fruitful application of canonical criticism. (This sense also has approval from Barton, for example, who is otherwise critical of canonical criticism; in Barton and Reimer eds 1996, especially pp. 70–71. See also Clements 1996, pp. 211–12.)")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-008"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Think about")])]), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("CANON AND BIBLICAL THEOLOGY")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Do you see similarities and differences between canonical criticism, as defined here, and what might be called ‘biblical theology’? Both these terms can be differently defined, so one has to be careful about what exactly is meant. But the comparison says something about the spirit of canonical criticism. It is at heart theological, and it requires the reader or interpreter, in the end, to make theological connections. This is not an exact science. However, it is perhaps the beginning of theology.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I have tried to say something about canon and biblical theology in ‘Biblical Theology: Canon and Plain Sense’ (McConville 2001).")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_XXIX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("FURTHER READING")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("This bibliography contains works referred to in the Introduction, and also serves as a general bibliography for the whole book. Items marked * are considered suitable as first ports of call, while others are more complex, or relate to specific issues.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-009"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("INTRODUCTIONS TO THE OLD TESTAMENT")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("B. S. Childs "), _c('i', [_vm._v("Introduction to the Old Testament as Scripture")]), _vm._v(". London: SCM, 1979.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("*R. B. Dillard and T. Longman III "), _c('i', [_vm._v("An Introduction to the Old Testament")]), _vm._v(". Grand Rapids: Zondervan/Leicester: Apollos, 1995.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("S. R. Driver "), _c('i', [_vm._v("Introduction to the Literature of the Old Testament")]), _vm._v(". Edinburgh: T. & T. Clark, 1892.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("G. Fohrer "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(". London: SPCK, 1970.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("*W. LaSor, D. A. Hubbard, F. W. Bush "), _c('i', [_vm._v("Old Testament Survey: the Message, Form, and Background of the Old Testament")]), _vm._v(". Grand Rapids: Eerdmans, 1996, second edition.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("*J. A. Soggin "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(". London: SCM, 1980, revised edition.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-010"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("INTERPRETING THE OLD TESTAMENT")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("J. Barton "), _c('i', [_vm._v("Reading the Old Testament")]), _vm._v(". London: DLT, 1996, second edition.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-011"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("ONE-VOLUME BIBLE COMMENTARIES")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("D. A. Carson, R. T. France, J. A. Motyer and")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("G. J. Wenham eds "), _c('i', [_vm._v("The New Bible Commentary Twenty-First Century Edition")]), _vm._v(". Leicester: IVP, 1994.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("J. Barton and J. Muddiman eds "), _c('i', [_vm._v("The Oxford Bible Commentary")]), _vm._v(". Oxford: OUP, 2001.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-012"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("BOOKS ON THE PROPHETS")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("J. Blenkinsopp "), _c('i', [_vm._v("A History of Prophecy in Israel")]), _vm._v(". London: SPCK, 1984.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("R. E. Clements "), _c('i', [_vm._v("Old Testament Prophecy: From Oracles to Canon")]), _vm._v(". Louisville: Westminster John Knox, 1996.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("*T. Collins "), _c('i', [_vm._v("The Mantle of Elijah; the Redaction Criticism of the Prophetical Books")]), _vm._v(". Sheffield; JSOT Press, 1993.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("P. R. Davies ed. "), _c('i', [_vm._v("The Prophets: A Sheffield Reader")]), _vm._v(". The Biblical Seminar; Sheffield Academic Press, 1996.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("R. P. Gordon "), _c('i', [_vm._v("The Place Is Too Small For Us: The Israelite Prophets in Recent Scholarship")]), _vm._v(". SBTS 5; Winona Lake: Eisenbrauns, 1995.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("K. Koch "), _c('i', [_vm._v("The Prophets 1, 2. ")]), _vm._v("London: SCM, 1982–83.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("J. Lindblom "), _c('i', [_vm._v("Prophecy in Ancient Israel")]), _vm._v(". Oxford: Basil Blackwell, 1962.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("G. von Rad "), _c('i', [_vm._v("Old Testament Theology II")]), _vm._v(". London: SCM, 1965.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("*J. F. A. Sawyer "), _c('i', [_vm._v("Prophecy and the Biblical Prophets")]), _vm._v(". Oxford: OUP, 1993.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-013"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("OTHER BOOKS AND ARTICLES")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("A. G. Auld ‘Prophets Through the Looking Glass: Between Writings and Moses’ in P. R. Davies ed. "), _c('i', [_vm._v("The Prophets: A Sheffield Reader")]), _vm._v(". The Biblical Seminar 42; Sheffield: Sheffield Academic Press, 1996, pp. 22–42.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("J. L. Austin "), _c('i', [_vm._v("How to Do Things With Words")]), _vm._v(". Oxford: Clarendon, 1962.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("H. M. Barstad ‘No Prophets? Recent Developments in Biblical Prophetic Research and Ancient Near Eastern Prophecy’ in P. R. Davies ed. "), _c('i', [_vm._v("The Prophets: A Sheffield Reader")]), _vm._v(". The Biblical Seminar 42; Sheffield: Sheffield Academic Press, 1996, pp. 106–26.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("John Barton ‘The Canonical Meaning of the Book of the Twelve’ in J. Barton and D. Reimer eds "), _c('i', [_vm._v("After the Exile: Essays in Honour of Rex Mason")]), _vm._v(". Macon, Ga; Mercer University Press, 1996, pp. 59–73.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("W. H. Bellinger "), _c('i', [_vm._v("Psalmody and Prophecy")]), _vm._v(". Sheffield: JSOT Press, 1984.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("R. P. Carroll, ‘Poets Not Prophets: A Response to “Prophets Through the Looking Glass”’ in P. R. Davies ed. "), _c('i', [_vm._v("The Prophets: A Sheffield Reader")]), _vm._v(". The Biblical Seminar 42; Sheffield: Sheffield Academic Press, 1996, pp. 43–49.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxix"
    }
  }, [_vm._v("R. E. Clements ‘Patterns in the Prophetic Canon’ in G. W. Coats and B. O. Long eds "), _c('i', [_vm._v("Canon and Authority: Essays in Old Testament Religion and Theology")]), _vm._v(". Philadelphia: Fortress, 1977, pp. 42–55.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_XXX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("R. E. Clements ‘Prophecy as Literature: a Reappraisal’ in D. G. Miller ed. "), _c('i', [_vm._v("The Hermeneutical Quest: Essays in Honor of J. L. Mays for His Sixty-Fifth Birthday")]), _vm._v(". Allison Park, Pa.: Pickwick Publications, 1986, pp. 56–76; reproduced in R. E. Clements "), _c('i', [_vm._v("Old Testament Prophecy: From Oracles to Canon")]), _vm._v(". Louisville: Westminster John Knox, 1996, pp. 203–16 (cited here).")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("R. Coggins ‘Interbiblical Quotations in Joel’ in J. Barton and D. Reimer eds "), _c('i', [_vm._v("After the Exile: Essays in Honour of Rex Mason")]), _vm._v(". Macon, Ga; Mercer University Press, 1996, pp. 75–84.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("P. Cotterell and M. Turner "), _c('i', [_vm._v("Linguistics and Biblical Interpretation")]), _vm._v(". London: SPCK, 1989.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("J. L. Crenshaw "), _c('i', [_vm._v("Old Testament Wisdom: An Introduction")]), _vm._v(". London: SCM, 1981.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("B. Duhm "), _c('i', [_vm._v("Das Buch Jeremia")]), _vm._v(". Tübingen and Leipzig: Mohr, 1901.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("B. Duhm "), _c('i', [_vm._v("Das Buch Jesaja übersetzt und erklärt")]), _vm._v(". Göttingen: Vandenhoeck and Ruprecht, fourth edition, 1922; first edition, 1892.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("A. R. Johnson "), _c('i', [_vm._v("The Cultic Prophet and Israel’s Psalmody")]), _vm._v(". Cardiff: University of Wales Press, 1979.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("A. R. Johnson "), _c('i', [_vm._v("The Cultic Prophet in Ancient Israel")]), _vm._v(". Cardiff: University of Wales Press, 1944.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("H. Lalleman-de Winkel "), _c('i', [_vm._v("Jeremiah in Prophetic Tradition")]), _vm._v(". Leuven: Peeters, 2000.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("A. Malamat ‘Prophecy at Mari’ in R. P. Gordon, ed. "), _c('i', [_vm._v("The Place Is Too Small for Us: The Israelite Prophets in Recent Scholarship")]), _vm._v(". SBTS 5; Winona Lake: Eisenbrauns, 1995, pp. 50–73.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("J. G. McConville ‘Biblical Theology: Canon and Plain Sense’ "), _c('i', [_vm._v("SBET 2 ")]), _vm._v("(2001), pp. 134–57.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("W. McKane "), _c('i', [_vm._v("A Late Harvest: Reflections on the Old Testament")]), _vm._v(". Edinburgh: T. & T. Clark, 1995.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("A. R. Millard ‘La prophétie et l’écriture: Israël, Aram, Assyrie’ "), _c('i', [_vm._v("RHR ")]), _vm._v("202, 1985, pp. 125–45.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("P. D. Miller ‘The Theological Significance of Biblical Poetry’ in P. D. Miller "), _c('i', [_vm._v("Israelite Religion and Biblical Theology")]), _vm._v(". JSOT Suppl. 267; Sheffield: Sheffield Academic Press, 2000, pp. 233–49.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("J. Muilenburg ‘Form Criticism and Beyond’ "), _c('i', [_vm._v("JBL ")]), _vm._v("88, 1969, pp. 1–18.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("E. W. Nicholson "), _c('i', [_vm._v("God and His People: Covenant and Theology in the Old Testament")]), _vm._v(". Oxford: Clarendon, 1986.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("T. W. Overholt ‘Prophecy in History: the Social Reality of Intermediation’ in P. R. Davies "), _c('i', [_vm._v("The Prophets: A Sheffield Reader")]), _vm._v(". The Biblical Seminar 42; Sheffield Academic Press, 1996, pp. 61–84.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("D. Patrick and A. Scult "), _c('i', [_vm._v("Rhetoric and Biblical Interpretation")]), _vm._v(". Sheffield: Almond Press, 1990.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("D. L. Petersen "), _c('i', [_vm._v("The Roles of Israel’s Prophets")]), _vm._v(". JSOT Suppl. 17; Sheffield; JSOT Press, 1981.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("H. H. Rowley "), _c('i', [_vm._v("Worship in Ancient Israel")]), _vm._v(". London: SPCK, 1967.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("Y. Sherwood ‘Of Fruit and Corpses and Wordplay Visions: Picturing Amos 8:1–3’ "), _c('i', [_vm._v("JSOT ")]), _vm._v("92, 2001, pp. 5-27.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("J. Skinner, "), _c('i', [_vm._v("Prophecy and Religion")]), _vm._v(". Cambridge: CUP, 1922.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("J. M. Soskice "), _c('i', [_vm._v("Metaphor and Religious Language")]), _vm._v(". Oxford: OUP, 1995.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("G. Steiner "), _c('i', [_vm._v("Real Presences")]), _vm._v(". Chicago: University of Chicago Press, 1989.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("L. Stulman "), _c('i', [_vm._v("The Prose Sermons of the Book of Jeremiah")]), _vm._v(". SBL Diss 83; Atlanta: Scholars Press, 1986.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("G. M. Tucker "), _c('i', [_vm._v("Form Criticism of the Old Testament")]), _vm._v(". Philadelphia: Fortress Press, 1971.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("C. Westermann "), _c('i', [_vm._v("Basic Forms of Prophetic Speech")]), _vm._v(". Cambridge: Lutterworth; Louisville: Westminster/John Knox, 1991.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("H. G. M. Williamson ‘A Response to Graeme Auld’ in P. R. Davies ed. "), _c('i', [_vm._v("The Prophets: A Sheffield Reader")]), _vm._v(". The Biblical Seminar 42; Sheffield Academic Press, 1996, pp. 50–56.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("H. G. M. Williamson ‘Isaiah and the Wise’, in J. Day, R. P. Gordon and H. G. M. Williamson eds "), _c('i', [_vm._v("Wisdom in Ancient Israel: Essays in Honour of J. A. Emerton")]), _vm._v(". Cambridge: CUP, 1995.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("R. R. Wilson "), _c('i', [_vm._v("Prophecy and Society in Ancient Israel")]), _vm._v(". Philadelphia: Fortress, 1980.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxx"
    }
  }, [_vm._v("N. Wolterstorff "), _c('i', [_vm._v("Divine Discourse")]), _vm._v(". Cambridge: CUP, 1995.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_XXXI"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-xxxi"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "Tabpxxxi"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("AB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Anchor Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("ANET")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("J. B. Pritchard (ed.), "), _c('i', [_vm._v("Ancient Near Eastern Texts")]), _vm._v(". Princeton University Press, 1969, third edition.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("AUSS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Andrews University Seminary Studies")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("BASOR")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("BBB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Bonner Biblische Beiträge")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("BETL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Bibliotheca Ephemeridum")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Theologicarum Lovaniensium")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("BHT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Beiträge zur historischen Theologie")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("BST")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Bible Speaks Today")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("BZAW")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("CBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Cambridge Bible Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("DSB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Daily Study Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("ExpTim")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Expository Times")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("FOTL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Forms of Old Testament Literature")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("HSM")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Harvard Semitic Monographs")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("IBD")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Illustrated Bible Dictionary")]), _vm._v(".")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Leicester: IVP, 1980.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("ICC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("International Critical")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("JBL")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("JSOT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Journal for the Study of the Old Testament")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("JSOT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Journal for the Study of the Old")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Suppl.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Testament Supplement Series")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("JSS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Journal of Semitic Studies")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("JTS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Journal of Theological Studies")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("LXX")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Septuagint (Greek Old Testament)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("MT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Masoretic Text (Hebrew text of the Old Testament)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("NCB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("New Century Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("NIBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("New International Biblical Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("NICOT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("NIDOTTE")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("W. VanGemeren (ed.), "), _c('i', [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(". Grand Rapids: Zondervan, 1997.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("NIGTC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("New International Greek")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Testament Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("NSBT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("New Studies in Biblical Theology")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("OAN")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Oracles Against the Nations")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("OBC")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("J. Barton and J. Muddimann (eds), "), _c('i', [_vm._v("Oxford Bible Commentary")]), _vm._v(". OUP, 2001.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("OS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Oudtestamentische Studiën")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("OTG")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Old Testament Guides")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("OTL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Old Testament Library")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("POT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("De Prediking van het Oude Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("RevExp")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Review and Expositor")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("RHR")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Revue d’histoire et de philosophie religieuses")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("SBET")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Scottish Bulletin of Evangelical Theology")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("SBL Diss")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("SBT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Studies in Biblical Theology")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("SBTS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Sources for Biblical and Theological Study")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("SOTBT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Studies in Old Testament Biblical Theology")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("TB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Tyndale Bulletin")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("TOTC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Tyndale Old Testament Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("VT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Vetus Testamentum")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("VT Suppl.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Vetus Testamentum Supplements")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("WBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Word Biblical Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("WMANT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Wissenschaftliche Monographien zum Alten und Neuen Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("ZAW")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 72
// module chunks = 0